import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewPageBaseComponent } from '../review-page-base/review-page-base.component';
import { SiteService } from '../../../services/data/site.service';
import { CountryService } from '../../../services/data/country.service';
import { EnumTranslationService } from '../../../services/enum-translation.service';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormlyDateSelectionComponent } from '../../../components/formly/formly-date-selection/formly-date-selection.component';
import { FormlyFileSelectionComponent } from '../../../components/formly/formly-file-selection/formly-file-selection.component';
import { getCompanyInformationSection, getPassportSection, getPersonalInformationSection, getRegistrationFormHeader, reasonForVisitSection, getRequiredDocumentationSection, sipsiCertificateSection, workPermitSection, workVisaSection, getEHSSection } from '../../../components/forms/base-registration-form/form-field-config';
import { VisitorRegistrationFormType } from '../../../models/visitor-registration-form-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-short-term-assignment-page',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    TranslateModule,
    ReactiveFormsModule,
    NgbTooltip,
    NgbDatepickerModule,
    FormlyDateSelectionComponent,
    FormlyFileSelectionComponent,
  ],
  templateUrl: './short-term-assignment-page.component.html',
  styleUrl: './short-term-assignment-page.component.scss'
})
export class ShortTermAssignmentPageComponent extends ReviewPageBaseComponent {

  constructor(
    _siteService: SiteService,
    _countryService: CountryService,
    _enumTranslationService: EnumTranslationService,
  ) {
    super(VisitorRegistrationFormType.WorkOnSite)

    // Intialize form fields
    this.fields = [
      ...getRegistrationFormHeader(_siteService, _enumTranslationService),
      ...getPersonalInformationSection(_enumTranslationService),
      ...getPassportSection(_countryService),
      ...workPermitSection,
      ...workVisaSection,
      ...getCompanyInformationSection(true),
      ...reasonForVisitSection,
      ...sipsiCertificateSection,
      ...getRequiredDocumentationSection(),
      ...getEHSSection()
    ];
  }
}
